export default function mapNumber(value: number, fromMin: number, fromMax: number, toMin: number, toMax: number): number {
    const mapped01 = (value - fromMin) / (fromMax - fromMin);
    return (mapped01 * (toMax - toMin)) + toMin;
}
